import { FC } from 'react'
import { createPortal } from 'react-dom'
import { KeyboardControlIcons, MouseControlIcons } from '@/js/editor/components/poi/ControlIcons.tsx'
import { ArrowLeftToLine } from 'lucide-react'

interface ControlHintsProps {
    mode: string
}

export const ControlHints: FC<ControlHintsProps> = ({ mode }) => {
    return (
        <>
            {createPortal(
                <div className={'fixed bottom-4 right-4 shadow-lg bg-white rounded-lg p-4 text-sm z-400'}>
                    <table className={'border-separate border-spacing-x-2 border-spacing-y-1'}>
                        <tbody>
                            <tr>
                                <td>
                                    <MouseControlIcons button={'LMB'} />
                                </td>
                                <td>Punkt platzieren</td>
                            </tr>
                            {mode === 'Polygon' && (
                                <tr>
                                    <td>
                                        <MouseControlIcons button={'RMB'} /> /{' '}
                                        <KeyboardControlIcons>
                                            <ArrowLeftToLine className={'ml-2'} height={18} />
                                        </KeyboardControlIcons>
                                    </td>
                                    <td>letzten Punkt entfernen</td>
                                </tr>
                            )}
                            <tr>
                                <td>
                                    <KeyboardControlIcons>ESC</KeyboardControlIcons>
                                </td>
                                <td>Zeichnen abbrechen</td>
                            </tr>
                        </tbody>
                    </table>
                </div>,
                document.body
            )}
        </>
    )
}
